import React, { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { RootState } from '../store'

const Drawer: FunctionComponent = ({ children }) => {

  const location = useLocation()
  const genralLan = useSelector(
    (rootState: RootState) => rootState.language.language?.content?.general!
  );
  const role = useSelector((rootState: RootState) => rootState.authReducer.UserDetails?.swt_role);
  const links = [
    { link: '/profile/', label: genralLan?.personal_information, roles: ['swt_admin', 'provider', 'client'] },
    { link: '/profile/projects', label: genralLan?.my_projects, roles: ['swt_admin', 'provider'] },
    { link: '/profile/tours', label: genralLan?.my_tours, roles: ['swt_admin', 'provider'] },
    { link: '/profile/requests', label: genralLan?.requests, roles: ['swt_admin'] },
    { link: '/profile/my-reservations', label: role === 'client' ? genralLan?.my_reservations : genralLan?.my_bookings, roles: ['provider', 'client'] },
    { link: '/profile/users', label: genralLan?.users, roles: ['swt_admin'] },
    // { link: '/update/payment', label: 'Pending Payments', roles: ['swt_admin', 'client'] },
    // { link: '/profile/faqs',            label: 'faqs',                    roles: ['swt_admin']                        },
    // { link: '/profile/latest-news',     label: 'latest news',             roles: ['swt_admin']                        },
    // { link: '/profile/contents',        label: 'contents',                roles: ['swt_admin']                        },
  ]

  const getNavProps = (link: any) => ({
    className: `nav-link ${link === "/profile/"
      ? location.pathname == "/profile/" ? "active" : ""
      : location.pathname.includes(link) ? "active" : ""
      }`,
    to: link,
  });

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <div className="sa-sidebar paddresup com-font">
            <div className="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              {
                links
                  .filter(l => l.roles.includes(role!))
                  .map(l => <Link key={l.label} {...getNavProps(l.link)}>{l.label}</Link>)
              }
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>

  )
}

export default Drawer